import type { LocalMessage } from '@swchat/client-sdk';
import { createContext, useContext, useMemo, useState, type ReactNode } from 'react';
import { isInlineImage } from '../lib/display';
import { LazyImageViewer } from './lazy';

const OpenImage = createContext<((messageId: string) => void) | null>(null);

/** Hàm mở trình xem ảnh cho một tin ảnh; null nếu nơi này không có album (ảnh không bấm được). */
export const useOpenImage = () => useContext(OpenImage);

/** Ảnh xem được: tin file ảnh còn nguyên, theo thứ tự trong `messages`. */
export function albumImages(messages: LocalMessage[]): LocalMessage[] {
  return messages.filter((m) => !m.deleted && m.type === 'file' && !!m.file && isInlineImage(m.file));
}

/**
 * Album của một danh sách tin (hội thoại hoặc luồng): bấm ảnh trong bong bóng → mở trình xem toàn màn hình, trượt qua
 * lại giữa mọi ảnh của danh sách. Trình xem nạp lười (không tính vào bundle chính).
 */
export function ImageAlbum({
  messages,
  senderName,
  children,
}: {
  messages: LocalMessage[];
  senderName: (userId: string) => string | undefined;
  children: ReactNode;
}) {
  const [openId, setOpenId] = useState<string>();
  const images = useMemo(() => albumImages(messages), [messages]);
  return (
    <OpenImage.Provider value={setOpenId}>
      {children}
      {openId && images.some((m) => m.id === openId) && (
        <LazyImageViewer images={images} startId={openId} senderName={senderName} onClose={() => setOpenId(undefined)} />
      )}
    </OpenImage.Provider>
  );
}
